'use strict';

import { Mesh, ShaderMaterial } from 'three';
import vertex from './vertex.glsl';
import fragment from './fragment.glsl';
import {Cloudflare} from "../../../api/Cloudflare";

export class Plug {
  #active = config.features.liteMode.settings.plug?.active || false;
  #url = null;
  #loader = null;
  #dayTexture = null;
  #nightTexture = null;
  #mesh = null;
  #material = null;
  #ready = false;

  constructor (url,dayTexture,nightTexture,loader) {
    this.#url = `${url}${config.features.liteMode.settings.plug?.path}?v=${Cloudflare.version}` || '';
    this.#dayTexture = dayTexture;
    this.#nightTexture = nightTexture;
    this.#loader = loader;

    return this;
  }

  create(){
    if (!this.#active) return new Promise(resolve => resolve('disabled'));

    return new Promise(resolve => {

      this.#loader.load(this.#url, model => {
        model.traverse(el => {
          if (el.isMesh) {
            const geometry = el.geometry.clone();
            this.#material = new ShaderMaterial({
              vertexShader: vertex,
              fragmentShader: fragment,
              uniforms: {
                dayTexture: {
                  value: this.#dayTexture
                },
                nightTexture: {
                  value: this.#nightTexture
                },
                uTimesOfDay: {
                  value: 0.0
                }
              },
              depthTest: false,
              depthWrite: false,
              transparent: true,
              opacity: 1
            });

            this.#mesh = new Mesh(geometry,this.#material);
            this.#mesh.name = el.name;
            this.#mesh.scale.copy(el.scale);
            this.#mesh.position.set(0,0,-0.2);
            this.#ready = true;
            resolve(this.#mesh);
          }
        });
      });

    });
  }

  updateTimesOfDay(time){
    if (this.#ready) {
      this.#material.uniforms.uTimesOfDay.value = time;
    }
  }

  switcher(state) {
    if (this.#ready) {
      switch (state) {
        case 'show':
          this.#mesh.visible = true;
          break;
        case 'hide':
          this.#mesh.visible = false;
          break;
      }
    }
  }
}
